import { matchPath } from "react-router-dom";

import type { AppState } from "./store";

export const getSearchString = (state: AppState) => state.router.location.search;

export interface RouteParams {
  pathOrganizationUuid: string;
  extraPath?: string;
  vehicleId?: string;
}

export const getRouteOrgUuid = (state: AppState) =>
  matchPath<RouteParams>(state.router.location.pathname, {
    path: "/o/:pathOrganizationUuid/:extraPath?",
    strict: true,
  })?.params.pathOrganizationUuid;

const FLIGHT_LIVE_PATH = "/o/:pathOrganizationUuid/flight/live/:vehicleId?" as const;

/** Vehicle id from an org-prefixed live RFD pathname (same matching rules as {@link getRouteVehicleId}). */
export const getVehicleIdFromFlightLivePathname = (pathname: string) =>
  matchPath<RouteParams>(pathname, { path: FLIGHT_LIVE_PATH, strict: true })?.params.vehicleId;

export const getRouteVehicleId = (state: AppState) =>
  getVehicleIdFromFlightLivePathname(state.router.location.pathname);
